<template>
  <b-overlay :show="busy" rounded="sm">

    <b-card class="standardpage reports invoices border-none">
      <!-- <b-card-header class="py-1 mb-2">
        <i :class="options.icon" class="text-primary mr-1"></i>
        {{ item.slac }}
        <span class="text-warning"
          >&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span
        >
      </b-card-header> -->
      <div class="availtable datatable text-left">
        <b-card-body class="py-0">
          <b-tabs class="gridtabs">
            <b-tab :active="true">
              <template #title>
                <div class="badgecontainer pr-5">
                  <i :class="options.icon" class="text-primary mr-1"></i>
                  <span class="text-center badgenormal badge-secondary badge-pill">
                    {{ item.id }}
                  </span>
                  <span class="text-warning">&lt;{{ selection.length == 0 ? "new" : "edit" }}&gt;</span>
                </div>
              </template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12">
                    <b-form-group label-cols="12" label="Client SL A/C" label-size="sm">
                      <treeselect placeholder="Select slac..." searchPromptText="Type at least 3 chars..."
                        v-model="item.slac" :clearable="true" :async="true" :load-options="treeselect_loadSLAC"
                        :show-count="true" :flatten-search-results="true" :disable-branch-nodes="true" :matchKeys="['id']"
                        search-nested :disabled="false" :multiple="true">
                        <div slot="value-label" slot-scope="{ node }">
                          {{ node.raw.id }}
                        </div>
                      </treeselect>
                    </b-form-group>
                  </b-col>

                </b-row>
                <b-row>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="PCC" label-for="pcc" label-cols="12">
                      <treeselect instanceId="pcc" v-model="item.pcc" :clearable="true" :multiple="false"
                        :options="options_pcc">
                      </treeselect>
                    </b-form-group>
                  </b-col>


                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Zone" label-for="zone" label-cols="12">
                      <b-form-radio-group id="zone" v-model="item.zone" :options="[
                        { text: 'LCC', value: 'LCC' },
                        { text: 'UK', value: 'UK' },
                        { text: 'EEC', value: 'EEC' },
                        { text: 'NEEC', value: 'NEEC' },
                      ]" buttons button-variant="outline-success" size="sm"
                        name="radio-btn-outline"></b-form-radio-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Fee" label-for="fee" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.fee" placeholder="Enter Fee" size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.fee = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Category" label-for="category" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.category" placeholder="Enter Category"
                          size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.category = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col cols="12">
                    <b-form-group label="Notes" label-for="notes" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.notes" placeholder="Enter notes" size="sm"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.notes = ''">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </p>
            </b-tab>
            <b-tab v-if="idselected">
              <template #title>
                <i class="fa fa-history text-primary mr-1"></i> Audit
              </template>
              <p class="py-3 px-0">
                <b-row>
                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Created At" label-for="created_at" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.created_at" button-only label-help="" locale="en-GB"
                            :disabled="true"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.created_at" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.created_at = null"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Created By" label-for="created_by" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.created_by" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.created_by = ''" :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Updated At" label-for="updated_at" label-cols="12">
                      <b-input-group>
                        <b-input-group-prepend>
                          <b-form-datepicker size="sm" v-model="item.updated_at" button-only label-help="" locale="en-GB"
                            :disabled="true"></b-form-datepicker>
                        </b-input-group-prepend>
                        <b-form-input size="sm" id="date" v-model="item.updated_at" type="text" placeholder="YYYY-MM-DD"
                          autocomplete="off" :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.updated_at = null"
                            :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col cols="12" sm="6" md="4" xl="3">
                    <b-form-group label="Updated By" label-for="updated_by" label-cols="12">
                      <b-input-group>
                        <b-form-input type="text" v-model="item.updated_by" placeholder="" size="sm"
                          :disabled="true"></b-form-input>
                        <b-input-group-append>
                          <b-button size="sm" variant="outline-secondary" @click="item.updated_by = ''" :disabled="true">
                            <i class="fa fa-remove"></i>
                          </b-button>
                        </b-input-group-append>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </p>
            </b-tab></b-tabs>
        </b-card-body>
        <b-card-footer class="nopadding mt-2">
          <b-row no-gutters>
            <b-col cols="auto" class="text-left mr-3">
              <b-button squared size="sm" variant="primary" @click="saveit" v-if="user.permissions.includes('setup_ticketingfees.admin')">
                <i class="fa fa-check"></i>
                Save It
              </b-button>
            </b-col>
            <b-col class="text-left my-auto">
              <div v-if="busy">
                <i class="fa fa-spinner fa-spin text-primary"></i>
              </div>
              <div v-else>
                <span v-html="message"></span>
              </div>
            </b-col>
            <b-col class="text-right" cols="8">
              <b-button squared size="sm" variant="secondary" class="mr-1" @click="discard">
                <i class="fa fa-chevron-left pr-1"></i>
                Back
              </b-button>
            </b-col>
          </b-row>
        </b-card-footer>

      </div>
    </b-card>
  </b-overlay>
</template>

<script>
import gql from "graphql-tag";

export default {
  name: "TransactionFeeEdit",
  data() {
    return {
      busy: false,
      options_pcc: [],
      item: {
        slac: [],
      },
      options: {
        title: "Ticketing Fees",
        icon: "fa fa-building",
      },
    };
  },
  async mounted() {
    let data = await this.$helpers.getsystemsetting("pnr_pcc");
    if (data) {
      this.options_pcc = JSON.parse(data);
    }

  },
  watch: {
    selection() {
      this.load();
    },
  },
  methods: {
    async load() {

      let variables = {
        id: this.selection[0].id,
        dateformat: "YYYY-MM-DD",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query setup_ticketingfees($id: String) {
              setup_ticketingfees(id: $id) {
                id
                category
                slac
                pcc
                zone
                fee
                notes
                created_at
                created_by
                updated_at
                updated_by
              }
            }
          `,
          variables,
        });

        if (response.data.setup_ticketingfees.length > 0) {
          this.item = response.data.setup_ticketingfees[0];

          this.item.slac = this.item.slac ? this.item.slac.split(",") : [];
        }
      } catch (error) {
        console.log(error);
      }
      this.busy = false;
    },
    async saveit() {
      this.busy = true;

      let row = this.cleanit(this.item);
      row.slac = row.slac.length > 0 ? row.slac.join(",") : null;

      let variables = { rows: [row] };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation setup_ticketingfees_save(
              $rows: [setup_ticketingfees_input]
              $dateformat: String
            ) {
              setup_ticketingfees_save(rows: $rows, dateformat: $dateformat) {
                id
                category
                slac
                pcc
                zone
                fee
                notes
              }
            }
          `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },
  },
};
</script>

<style></style>